"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatiAnagraficiCedacriDtoToJSON = exports.DatiAnagraficiCedacriDtoFromJSONTyped = exports.DatiAnagraficiCedacriDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function DatiAnagraficiCedacriDtoFromJSON(json) {
    return DatiAnagraficiCedacriDtoFromJSONTyped(json, false);
}
exports.DatiAnagraficiCedacriDtoFromJSON = DatiAnagraficiCedacriDtoFromJSON;
function DatiAnagraficiCedacriDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ndg': !runtime_1.exists(json, 'ndg') ? undefined : json['ndg'],
        'filialeNdg': !runtime_1.exists(json, 'filialeNdg') ? undefined : json['filialeNdg'],
        'nome': !runtime_1.exists(json, 'nome') ? undefined : json['nome'],
        'cognome': !runtime_1.exists(json, 'cognome') ? undefined : json['cognome'],
        'codiceFiscale': !runtime_1.exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'emailAnagrafe': !runtime_1.exists(json, 'emailAnagrafe') ? undefined : json['emailAnagrafe'],
        'emailFirmaBiometrica': !runtime_1.exists(json, 'emailFirmaBiometrica') ? undefined : json['emailFirmaBiometrica'],
        'numeroCellulare': !runtime_1.exists(json, 'numeroCellulare') ? undefined : json['numeroCellulare'],
        'adesioneFirmaBiometrica': !runtime_1.exists(json, 'adesioneFirmaBiometrica') ? undefined : json['adesioneFirmaBiometrica'],
        'dataUltimaCertificazione': !runtime_1.exists(json, 'dataUltimaCertificazione') ? undefined : (json['dataUltimaCertificazione'] === null ? null : new Date(json['dataUltimaCertificazione'])),
        'isPersonaFisica': !runtime_1.exists(json, 'isPersonaFisica') ? undefined : json['isPersonaFisica'],
        'nominativo': !runtime_1.exists(json, 'nominativo') ? undefined : json['nominativo'],
    };
}
exports.DatiAnagraficiCedacriDtoFromJSONTyped = DatiAnagraficiCedacriDtoFromJSONTyped;
function DatiAnagraficiCedacriDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ndg': value.ndg,
        'filialeNdg': value.filialeNdg,
        'nome': value.nome,
        'cognome': value.cognome,
        'codiceFiscale': value.codiceFiscale,
        'emailAnagrafe': value.emailAnagrafe,
        'emailFirmaBiometrica': value.emailFirmaBiometrica,
        'numeroCellulare': value.numeroCellulare,
        'adesioneFirmaBiometrica': value.adesioneFirmaBiometrica,
        'dataUltimaCertificazione': value.dataUltimaCertificazione === undefined ? undefined : (value.dataUltimaCertificazione === null ? null : value.dataUltimaCertificazione.toISOString()),
        'isPersonaFisica': value.isPersonaFisica,
    };
}
exports.DatiAnagraficiCedacriDtoToJSON = DatiAnagraficiCedacriDtoToJSON;
